
import { Component, Vue, Prop } from 'vue-property-decorator';

import FormList from "./components/FormList.vue"

import { stepInfoType } from "@/types/Application";
import PageBase from "../PageBase.vue";

import GetHelpForPdf from "./helpPages/GetHelpForPDF.vue"
import GetHelpScanning from "./helpPages/GetHelpScanning.vue"
import moment from 'moment-timezone';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        PageBase,
        GetHelpForPdf,
        GetHelpScanning,
        FormList
    }
})    
export default class ReviewAndSave extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    // @applicationState.State
    // public requiredDocuments!: string[];

    @applicationState.Action
    public UpdateGotoPrevStepPage!: () => void

    @applicationState.Action
    public UpdateGotoNextStepPage!: () => void

    @applicationState.State
    public generatedForms!: string[];

    currentStep=0;
    currentPage=0;
    error = ""
    showGetHelpForPDF = false;
    showGetHelpScanning = false;
    applicationLocation = {name:'', address:'', cityStatePostcode:'', email:''}
    requiredDocuments: string[] = [];
    formsList = [];

    mounted(){

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        
        //this.setProgress()
           
        let location = this.$store.state.Application.applicationLocation
        if(!location) location = this.$store.state.Common.userLocation
        //console.log(location)

        if(location == 'Victoria'){
            this.applicationLocation = {name:'Victoria Law Courts', address:'850 Burdett Avenue', cityStatePostcode:'Victoria, B.C.  V8W 9J2', email:'Victoria.CourtScheduling@gov.bc.ca'}
        }else if(location == 'Surrey'){
            this.applicationLocation = {name:'Surrey Provincial Court', address:'14340 - 57 Avenue', cityStatePostcode:'Surrey, B.C.  V3X 1B2', email:'CSBSurreyProvincialCourt.FamilyRegistry@gov.bc.ca'}
        }  

        this.requiredDocuments = [];
        this.requiredDocuments = Vue.filter('extractRequiredDocuments')(this.getRepGrantResultData())


    }    
    
    public onPrev() {
        this.UpdateGotoPrevStepPage()
    }

    public onNext() {
        this.UpdateGotoNextStepPage()
    }

    public checkErrorOnPages(){

        const optionalLabels = ["Next Steps", "Review and Print", "Review and Save", "Review and Submit"]

        for(const step of this.$store.state.Application.steps){
            if(step.active){
                for(const page of step.pages){
                    if(page.active && page.progress!=100 && optionalLabels.indexOf(page.label) == -1){
                        this.$store.commit("Application/setCurrentStep", step.id);
                        this.$store.commit("Application/setCurrentStepPage", {currentStep: step.id, currentPage: page.key });
                        const nextChildGroup = document.getElementById(this.getStepGroupId(step.id));
                        // if(nextChildGroup){
                        //     if(Number(step.id)==8){
                        //         nextChildGroup.style.display = "none";
                        //         Vue.nextTick(()=>nextChildGroup.style.display = "block")
                        //     }else{
                        //         nextChildGroup.style.display = "block";
                        //     }
                        // }
                        return false;
                    }
                }
            }            
        }
        return true;
        
    }

    public setFormList(formsList){
        this.formsList = formsList
    }

    public getStepId(stepIndex) {
        return "step-" + stepIndex;
    }

    public getStepGroupId(stepIndex) {
        return this.getStepId(stepIndex) + "-group";
    }

    public getStepPageId(stepIndex, pageIndex) {
        return this.getStepId(stepIndex) + "-page-" + pageIndex;
    }

    public getRepGrantResultData() { 
        var result = this.$store.state.Application.steps[0].result; 
        for(var i=1;i<9; i++){
            const stepResults = this.$store.state.Application.steps[i].result
            for(const stepResult in stepResults){
                //console.log(stepResults[stepResult])
                //console.log(stepResults[stepResult].data)
                result[stepResult]=stepResults[stepResult].data; 
                //Object.assign(result, result,{$stepResult: stepResults[stepResult].data});  
            }
        }     
        // var result = this.$store.state.Application.steps[0].result; 
        // for(var i=1;i<9; i++)
        //     Object.assign(result, result, this.$store.state.Application.steps[i].result); 
        
        var deceasedDateOfDeath = {deceasedDateOfDeath: this.$store.state.Application.deceasedDateOfDeath}
        Object.assign(result, result, deceasedDateOfDeath);
        
        var applicationLocation = this.$store.state.Application.applicationLocation
        var userLocation = this.$store.state.Common.userLocation
        //console.log(applicationLocation)
        //console.log(userLocation)
        if(applicationLocation)
            Object.assign(result, result,{applicationLocation: applicationLocation}); 
        else
            Object.assign(result, result,{applicationLocation: userLocation});
        //console.log(result)
        return result;
    }

    // beforeDestroy() {
    //     const progress = this.$store.state.Application.steps[this.currentStep].pages[this.currentPage].progress
    //     const progress = this.pdfFileOpened? 100:50;
    //     console.log(progress)
    //     Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
    // }

}
